import AddNewProperties from "./../../components/AddNewProperty";
import React from 'react'

const AddNewProperty = () => {
  return (
    <>
    <AddNewProperties/>
    </>
  )
}

export default AddNewProperty